import { z } from 'zod';
import { positiveDecimalSchema, currencyCodeSchema, isoDateSchema, uuidSchema } from './common';

/** Bir ödeme planında en fazla taksit sayısı (kötü niyetli/yanlış girdiye karşı sınır). */
const MAX_INSTALLMENTS = 120;

export const paymentPlanStatusSchema = z.enum(['active', 'completed', 'cancelled']);
export type PaymentPlanStatus = z.infer<typeof paymentPlanStatusSchema>;

/**
 * Bir échéancier satırı (tek taksit): tutar + (opsiyonel) vade tarihi + ödendi mi.
 * Tarih null ise işlem güncel döneme düşer; doluysa o aya yönlendirilir.
 */
export const paymentPlanRowSchema = z.object({
  amount: positiveDecimalSchema,
  date: isoDateSchema.nullable().optional(),
  paid: z.boolean().optional().default(false),
});
export type PaymentPlanRowInput = z.infer<typeof paymentPlanRowSchema>;

/**
 * Ödeme planı (échéancier) oluşturma. Her satır gerçek bir Transaction olarak,
 * ortak bir PaymentPlan'a (payment_plan_id) bağlı, tarihine göre doğru döneme
 * yönlendirilmiş şekilde yaratılır. `paid:true` satırlar onaylı (ödenmiş) doğar.
 */
export const createPaymentPlanSchema = z.object({
  name: z.string().min(1).max(200),
  currency: currencyCodeSchema.default('EUR'),
  paymentCardId: uuidSchema.optional(),
  /**
   * 💳 Taksitlerin ödendiği para hesabı (ör. Belfius). Verilirse her taksit bu hesaba bağlı
   * doğar → ödenen taksit hesabın bakiyesini düşürür ve bütçe ↔ hesap mutabakatı tutar.
   * null/boş ise taksitler "hesapsız" doğar (eski davranış) — bu durumda ödenen taksit
   * bütçe net'ine girer ama hiçbir hesap bakiyesine yansımaz → sahte mutabakat farkı oluşur.
   */
  moneyAccountId: uuidSchema.nullable().optional(),
  description: z.string().max(1000).optional(),
  rows: z.array(paymentPlanRowSchema).min(2).max(MAX_INSTALLMENTS),
});
export type CreatePaymentPlanInput = z.infer<typeof createPaymentPlanSchema>;
